import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Headline',
  props: {
  textAlign: {
    type: String,
    default: 'center',
  },
  size: {
    type: String,
    default: 'h5',
  },
  tagName: {
    type: String,
    default: 'inherit',
  },
  className: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: 'dark',
  },
  colorLg: {
    type: String,
    default: 'inherit',
  },
  bold: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const tag = computed(() => (props.tagName !== 'inherit' ? props.tagName : props.size));

const classes = computed(() => {
  const headlineClasses = [];

  headlineClasses.push(`color-${props.color}`);

  if (props.colorLg !== 'inherit') {
    headlineClasses.push(`color-lg-${props.colorLg}`);
  }

  if (props.size !== tag.value) {
    headlineClasses.push(props.size);
  }

  if (props.bold) {
    headlineClasses.push('bold');
  }

  return headlineClasses;
});

const style = computed(() => {
  const styles = {} as Record<string, string>;

  if (props.textAlign !== 'inherit') {
    styles['--base-text-align'] = props.textAlign as string;
  }

  return styles;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tag)), {
    class: _normalizeClass(["io-headline", _unref(classes)]),
    style: _normalizeStyle(_unref(style))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "style"]))
}
}

})